export default __webpack_public_path__ + "static/recon-c12a485de172d56c908efbc812a31703.png";